import { render, staticRenderFns } from "./weight_set.vue?vue&type=template&id=9d2d3ace&"
import script from "./weight_set.vue?vue&type=script&lang=js&"
export * from "./weight_set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports